import React from 'react';

export interface DevicePickItem {
    code: string;
    name: string;
}

interface Props {
    /** 候选设备 (一般是某工艺框架下的全部设备) */
    items: DevicePickItem[];
    value: string[];
    onChange: (keys: string[]) => void;
    /** 标题 (含「不勾=…」的语义说明) */
    title: string;
    /** 没有候选时的占位: 还没选框架 / 框架下没有设备 */
    emptyHint?: string;
    /** 未勾选任何设备时的底部说明 */
    allHint?: string;
}

/** 绑定设备多选: 不勾 = 框架内全部设备, 勾选后只对所选设备生效 (字段组 / 方案类型等共用). */
const DeviceKeysPicker = ({
    items,
    value,
    onChange,
    title,
    emptyHint = '该框架暂无设备',
    allHint,
}: Props) => (
    <div>
        <div className="flex items-center justify-between mb-1">
            <label className="field-label mb-0">{title}</label>
            <div className="flex gap-2 text-xs">
                <button
                    type="button"
                    className="text-brand-600 hover:underline"
                    onClick={() => onChange(items.map((it) => it.code))}
                >
                    全选
                </button>
                <button
                    type="button"
                    className="text-slate-400 hover:text-slate-600"
                    onClick={() => onChange([])}
                >
                    清空 (=全部设备)
                </button>
            </div>
        </div>
        {items.length === 0 ? (
            <div className="text-xs text-slate-300 py-2">{emptyHint}</div>
        ) : (
            <div className="max-h-40 overflow-auto border border-slate-100 rounded-md p-2 grid grid-cols-2 gap-1">
                {items.map((it) => {
                    const checked = value.includes(it.code);
                    return (
                        <label
                            key={it.code}
                            className="flex items-center gap-1.5 text-xs text-slate-600 cursor-pointer"
                            title={it.code}
                        >
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() =>
                                    onChange(
                                        checked
                                            ? value.filter((k) => k !== it.code)
                                            : [...value, it.code],
                                    )
                                }
                            />
                            <span className="truncate">
                                {it.name}
                                {it.name !== it.code && (
                                    <span className="text-slate-400">
                                        {' '}
                                        ({it.code})
                                    </span>
                                )}
                            </span>
                        </label>
                    );
                })}
            </div>
        )}
        <div className="text-[11px] text-slate-400 mt-1">
            已绑定 {value.length} 台
            {value.length === 0 && allHint ? ` — ${allHint}` : ''}
        </div>
    </div>
);

export default DeviceKeysPicker;
